import { render, staticRenderFns } from "./DLGContactMe.vue?vue&type=template&id=5af3dd8b&"
import script from "./DLGContactMe.vue?vue&type=script&lang=js&"
export * from "./DLGContactMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports